<template>
    <div class="chat-box" id="nav-login-dia">
      <div class="user-selection">
        <label for="user-select">Select a userx:</label>
        <select id="user-select" v-model="selectedUser">
          <!-- <option v-for="user in userList" :key="user.Id">{{ user.CompanyName }}</option> -->
          <option v-for="user in userList" :key="user.Id" :value="user.Id">{{ user.CompanyName }}</option>
          <!-- <option v-for="user in userList" :key="user.id" :value="user.id">{{ user.name }}</option> -->
        </select>
        <h3>Message is: {{ selectedUser }}</h3>
      </div>
      <div class="message-list">
        <div v-for="message in messageList" :key="message.id" class="message-item">
          <div class="message-author">{{ message.author }}</div>
          <div class="message-text">{{ message.text }}</div>
        </div>
      </div>
      <div class="message-input">
        <input type="text" v-model="currentMessage" placeholder="Type a message...">
        <button @click="sendMessage">Send</button>
      </div>
    </div>
  </template>
  

<script>
import axios from 'axios'
export default {
  data() {
    return {
      userList: [], // list of users fetched from API
      selectedUser: null, // currently selected user
      messageList: [], // list of messages
      currentMessage: '' // current user's message
    }
  },
  mounted() {

    // this.$store.dispatch('category/fetchCompanyName').then(()=> 
    //     {
    //        this.userList.push(this.companyName[index]);    
    //       })
    // fetch list of users from API and store in userList data property
    // fetch('http://localhost:51239/api/public/category/company/')
    //   // .then(response => response.json())
    //   .then(data => {
    //     this.userList = data
    //   })
    //   .catch(error => {
    //     console.error(error)
    //   })

      axios.get('http://localhost:51239/api/public/category/company/')
      .then(response => {
        console.log("Hello = "+response.data.ResponseMessage);
        this.userList = response.data.Result;
        console.log("User List  =  ", this.userList);
      })
      .catch(error => {
        console.log(error)
      })
    
      // this.getUserList();
  },
  // computed: {
	// 	...mapState('category', [
  //           'companyName'
  //       ])
  // },
  methods: {
    // getUserList() {
    //   // make an API call to get the user list
    //   // assuming the API returns an array of user objects with "id" and "name" properties
    //   this.userList = { id: Id, name: CompanyName };
    // },
    sendMessage() {
      const message = {
        id: this.messageList.length + 1,
        author: 'User', // replace with current user's name
        text: this.currentMessage
      }
      this.messageList.push(message)
      this.currentMessage = ''
    }
  }
}
</script>
